<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Configurações: Segmentos'" :novo="novo" :titulo="'Configurações- Segmentos: ' + contentEdit.idioma" :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-12 form-group">
          <label>Idioma:</label>
          <input
            type="text"
            v-model="contentEdit.idioma"
            name="idioma"
            id="idioma"
            class="form-control required valid"
            value
          />
        </div>
        <div class="clearfix"></div>
        <div class="col-12 form-group">
          <label>Título</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="tituloSegmento"
            id="tituloSegmento"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12 form-group">
          <label>Subtítulo</label>
          <input
            type="text"
            v-model="contentEdit.subtitulo"
            name="subtitulo"
            id="subtitulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12"> 
          <hr>
          <h4>Configurações formulário</h4>
        </div>
        <div class="col-12 form-group">
          <label>Título</label>
          <input
            type="text"
            v-model="contentEdit.tituloFormulario"
            name="tituloFormulario"
            id="tituloFormulario"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Campo serviço</label>
          <input
            type="text"
            v-model="contentEdit.servico"
            name="servico"
            id="servico"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Campo email</label>
          <input
            type="text"
            v-model="contentEdit.email"
            name="email"
            id="email"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Campo telefone</label>
          <input
            type="text"
            v-model="contentEdit.telefone"
            name="telefone"
            id="telefone"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Campo nome</label>
          <input
            type="text"
            v-model="contentEdit.nome"
            name="nome"
            id="nome"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-4 form-group">
          <label>Campo enviar</label>
          <input
            type="text"
            v-model="contentEdit.enviar"
            name="enviar"
            id="enviar"
            class="form-control required valid"
            value
          />
        </div>
         <div class="col-12"> 
          <hr>
          <h4>Outras Configurações</h4>
        </div>
       <div class="col-4 form-group">
          <label>Botão contratar serviço</label>
          <input
            type="text"
            v-model="contentEdit.botaoContratar"
            name="botaoContratar"
            id="botaoContratar"
            class="form-control required valid"
            value
          />
        </div>
       <div class="col-4 form-group">
          <label>Botão outro segmento</label>
          <input
            type="text"
            v-model="contentEdit.botaoOutroSegmento"
            name="botaoOutroSegmento"
            id="botaoOutroSegmento"
            class="form-control required valid"
            value
          />
        </div>
       <div class="col-4 form-group">
          <label>Botão saiba mais</label>
          <input
            type="text"
            v-model="contentEdit.botaoSaibaMais"
            name="botaoSaibaMais"
            id="botaoSaibaMais"
            class="form-control required valid"
            value
          />
        </div>

       <div class="col-6 form-group">
          <label>Título Outro segmento <small>Box amarelo</small></label>
          <input
            type="text"
            v-model="contentEdit.tituloOutroServico"
            name="tituloOutroServico"
            id="tituloOutroServico"
            class="form-control required valid"
            value
          />
        </div>
       <div class="col-6 form-group">
          <label>Botão fale conosco <small>Box amarelo</small></label>
          <input
            type="text"
            v-model="contentEdit.botaoOutroServico"
            name="botaoOutroServico"
            id="botaoOutroServico"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-12 form-group">
          <label>Frase outro serviço</label>
          <textarea
            type="text"
            v-model="contentEdit.fraseOutroServico"
            name="fraseOutroServico"
            id="fraseOutroServico"
            class="form-control required valid"
            value
          >
          </textarea>
        </div>

        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData,getSuccess,getError,urlApi } from "../../global/utils";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      error:null,
      contentFotos: [],
      carregado:true,
      files: [],
      logotipoCabecalho: [],
      logotipoRodape: [],
      contentEdit: {
        titulo:'',
        ativo: false,
      },      
      customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ]

    };
  },
  components: { Tbheader  },
  methods: {
    fnLimpa(){
      this.contentEdit.titulo = ''
      this.contentEdit.ativo = ''
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
        this.$router.push({path: `/eoficinas/segmentosconfiguracoes/`})
    },
    async formSubmit(e) {
        e.preventDefault();
        const metodo = this.$route.params.id ? 'put' : 'post'
        const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : ''

       let data = await this.$http[metodo]("/eoficinas/segmentosconfig" + completaUrl,this.contentEdit)
        .then(() =>{
            getSuccess();
            this.fnLimpa();
            this.fnCancela();
        })
       .catch(e => {
        return  e
        }); 
        this.error = data
        

    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi+"eoficinas/segmentosconfig/"+valueId);
      this.contentEdit = data[0].content;
      this.fnCarregaIdiomas(valueId);
      this.$vs.loading.close()
    },   
    async fnCarregaIdiomas(valueId) {
      let data = await getData(this.urlApi+"eoficinas/idiomas/"+valueId);
      console.log(data);
      this.contentEdit.idioma = data[0].content.abreviacao;
    },   

  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#editor1,#editor2,#editor3{
	min-height: 50vh;
}
</style>